import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import About from '@/components/About'
import Part from '@/components/Part'
import Word from '@/components/Word'
import Log from '@/components/Timeline'

Vue.use(Router);

export default new Router({
  routes: [
    {path: "/", name: "homeLink", component: Home, meta:{}},
    {path: '/hello', name: 'HelloWorld', component: HelloWorld},
    {path: '/part', name: 'yysLink', component: Part},
    {path: '/word', name: 'wordLink', component: Word},
    {path: '/s', name: 'sLink', component: Part},
    {path: '/about', name: 'aboutLink', component: About},
    {path: '/log', name: 'logLink', component: Log},
    {path: "*", redirect: "/"}
  ],
  mode: "history"
})



// WEBPACK FOOTER //
// ./src/router/index.js